import validations, { ERRORS } from '../validations';
const ONLY_LETTERS = /^[a-zA-ZÀ-ž]{1}[a-zA-ZÀ-ž\'\s\-\.]{1,128}$/;
export default {
    mask: (v) => v,
    validate: validations((value) => (value ? ERRORS.none : ERRORS.required), (value) => (ONLY_LETTERS.test(value) ? ERRORS.none : ERRORS.invalid)),
};
